import axios from '@/service-library/api-axios'

export function verifyUserCode(code: string) {
  return axios.get(`v2/user/verify_code/${code}`)
}
